import { SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { ReceiptCent } from "lucide-react";
import { Create, DateInput, SelectInput, SimpleForm } from "../../common";

const statusChoices = [
  { id: "draft", name: "Draft" },
  { id: "processing", name: "Processing" },
  { id: "approved", name: "Approved" },
  { id: "paid", name: "Paid" },
];

const PayrollRunToolbar = () => (
  <div className="form-toolbar-premium">
    <SaveButton className="btn-green-action" label="Create Payroll Run" />
  </div>
);

export const PayrollRunCreate = () => (
  <Create title="Create Payroll Run">
    <Card className="form-container">
      <div className="form-header-premium">
        <ReceiptCent className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">Initiate Payroll Run</h2>
      </div>
      <SimpleForm toolbar={<PayrollRunToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <DateInput
            source="period_month"
            label="Period Month"
            helperText="Use the first day of the payroll month."
          />
          <SelectInput
            source="status"
            choices={statusChoices}
            defaultValue="draft"
          />
        </div>
      </SimpleForm>
    </Card>
  </Create>
);
